const PREFIX = 'LOGIN';

export const CHECK_AUTHENTICATION = `${PREFIX}/CHECK_AUTHENTICATION`;
export const LOGIN = `${PREFIX}/LOGIN`;
export const LOGIN_WAIT = `${PREFIX}/LOGIN_WAIT`;
export const CHECK_LOGIN = `${PREFIX}/CHECK_LOGIN`;
export const CANCEL_CHECK_LOGIN = `${PREFIX}/CANCEL_CHECK_LOGIN`;
export const LOGIN_FAILURE = `${PREFIX}/LOGIN_FAILURE`;
export const LOGIN_SUCCESS = `${PREFIX}/LOGIN_SUCCESS`;
export const LOGOUT = `${PREFIX}/LOGOUT`;
export const LOGOUT_SUCCESS = `${PREFIX}/LOGOUT_SUCCESS`;
export const USER_LOGGED = `${PREFIX}/USER_LOGGED`;
export const SET_AUTHENTICATION = `${PREFIX}/SET_AUTHENTICATION`;



// WEBPACK FOOTER //
// ./src/state/auth/auth.actionTypes.js